var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"add-to-cal",class:{
    'add-to-cal--clickable': _vm.isClickable,
    'add-to-cal--done': _vm.state === 'done',
  },on:{"click":_vm.addToCalendar}},[_c('span',{staticClass:"add-to-cal__title"},[_vm._v(" "+_vm._s(_vm.$t(_vm.titleLabel))+" ")]),_c('span',{staticClass:"add-to-cal__icon"},[_c('Icon',{attrs:{"name":_vm.iconName,"size":20}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }